
import Vue from "vue";
import { checkHasModule } from "@/router";
import { MODULE } from "@/config/modules";

export default Vue.extend({
	created(){
		if (!checkHasModule(MODULE.VOORRAADBEHEER, this.$router)){
			throw new Error("MISSING MODULE");
		}
	}
});

